import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getUser } from "@/lib/api";

export default function ProtectedRoute({ children, role }) {
  const location = useLocation();
  const user = getUser();
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/learn"} replace />;
  }
  return children;
}
